{
  "labels": {
    "paste": "Επικόλληση",
    "pasteAsPlaintext": "Επικόλληση ως απλό κείμενο",
    "pasteCharts": "Επικόλληση γραφημάτων",
    "selectAll": "Επιλογή όλων",
    "multiSelect": "Προσθέστε το στοιχείο στην επιλογή",
    "moveCanvas": "Μετακίνηση καμβά",
    "cut": "Αποκοπή",
    "copy": "Αντιγραφή",
    "copyAsPng": "Αντιγραφή στο πρόχειρο ως PNG",
    "copyAsSvg": "Αντιγραφή στο πρόχειρο ως SVG",
    "copyText": "Αντιγραφή στο πρόχειρο ως κείμενο",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Στο προσκήνιο",
    "sendToBack": "Ένα επίπεδο πίσω",
    "bringToFront": "Ένα επίπεδο μπροστά",
    "sendBackward": "Στο παρασκήνιο",
    "delete": "Διαγραφή",
    "copyStyles": "Αντιγραφή εμφάνισης",
    "pasteStyles": "Επικόλληση εμφάνισης",
    "stroke": "Μολυβιά",
    "background": "Φόντο",
    "fill": "Γέμισμα",
    "strokeWidth": "Πάχος μολυβιάς",
    "strokeStyle": "Στυλ περιγράμματος",
    "strokeStyle_solid": "Συμπαγής",
    "strokeStyle_dashed": "Διακεκομμένη με παύλες",
    "strokeStyle_dotted": "Διακεκομμένη με τελείες",
    "sloppiness": "Ακαταστασία",
    "opacity": "Διαφάνεια",
    "textAlign": "Στοίχιση κειμένου",
    "edges": "Άκρες",
    "sharp": "Οξύ",
    "round": "Στρογγυλό",
    "arrowheads": "Σύμβολα βελών",
    "arrowhead_none": "Κανένα",
    "arrowhead_arrow": "Βέλος",
    "arrowhead_bar": "Μπάρα",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Τρίγωνο",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Μέγεθος γραμματοσειράς",
    "fontFamily": "Γραμματοσειρά",
    "addWatermark": "Προσθήκη \"Φτιαγμένο με Excalidraw\"",
    "handDrawn": "Σχεδιασμένο στο χέρι",
    "normal": "Κανονική",
    "code": "Κώδικας",
    "small": "Μικρό",
    "medium": "Μεσαίο",
    "large": "Μεγάλο",
    "veryLarge": "Πολύ μεγάλο",
    "solid": "Συμπαγής",
    "hachure": "Εκκόλαψη",
    "zigzag": "",
    "crossHatch": "Διασταυρούμενη εκκόλαψη",
    "thin": "Λεπτή",
    "bold": "Έντονη",
    "left": "Αριστερά",
    "center": "Κέντρο",
    "right": "Δεξιά",
    "extraBold": "Πολύ έντονη",
    "architect": "Αρχιτέκτονας",
    "artist": "Καλλιτέχνης",
    "cartoonist": "Σκιτσογράφος",
    "fileTitle": "Όνομα αρχείου",
    "colorPicker": "Επιλογή Χρώματος",
    "canvasColors": "Χρησιμοποείται στον καμβά",
    "canvasBackground": "Φόντο καμβά",
    "drawingCanvas": "Σχεδίαση καμβά",
    "layers": "Στρώματα",
    "actions": "Ενέργειες",
    "language": "Γλώσσα",
    "liveCollaboration": "Live συνεργασία...",
    "duplicateSelection": "Δημιουργία αντιγράφου",
    "untitled": "Χωρίς τίτλο",
    "name": "Όνομα",
    "yourName": "Το όνομά σου",
    "madeWithExcalidraw": "Φτιαγμένο με Excalidraw",
    "group": "Δημιουργία ομάδας από επιλογή",
    "ungroup": "Κατάργηση ομάδας από επιλογή",
    "collaborators": "Συνεργάτες",
    "showGrid": "Προβολή πλέγματος",
    "addToLibrary": "Προσθήκη στη βιβλιοθήκη",
    "removeFromLibrary": "Αφαίρεση από τη βιβλιοθήκη",
    "libraryLoadingMessage": "Φόρτωση βιβλιοθήκης…",
    "libraries": "Άλλες βιβλιοθήκες",
    "loadingScene": "Φόρτωση σκηνής…",
    "align": "Στοίχιση",
    "alignTop": "Στοίχιση πάνω",
    "alignBottom": "Στοίχιση κάτω",
    "alignLeft": "Στοίχιση αριστερά",
    "alignRight": "Στοίχιση δεξιά",
    "centerVertically": "Κέντρο κάθετα",
    "centerHorizontally": "Κέντρο οριζόντια",
    "distributeHorizontally": "Οριζόντια κατανομή",
    "distributeVertically": "Κατακόρυφη κατανομή",
    "flipHorizontal": "Οριζόντια αναστροφή",
    "flipVertical": "Κατακόρυφη αναστροφή",
    "viewMode": "Λειτουργία προβολής",
    "share": "Κοινοποίηση",
    "showStroke": "Εμφάνιση επιλογέα χρωμάτων πινελιάς",
    "showBackground": "Εμφάνιση επιλογέα χρώματος φόντου",
    "toggleTheme": "Εναλλαγή θέματος",
    "personalLib": "Προσωπική Βιβλιοθήκη",
    "excalidrawLib": "Βιβλιοθήκη Excalidraw",
    "decreaseFontSize": "Μείωση μεγέθους γραμματοσειράς",
    "increaseFontSize": "Αύξηση μεγέθους γραμματοσειράς",
    "unbindText": "Αποσύνδεση κειμένου",
    "bindText": "Δέσμευση κειμένου στο δοχείο",
    "createContainerFromText": "",
    "link": {
      "edit": "Επεξεργασία συνδέσμου",
      "editEmbed": "",
      "create": "Δημιουργία συνδέσμου",
      "createEmbed": "",
      "label": "Σύνδεσμος",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "Επεξεργασία γραμμής",
      "exit": "Έξοδος επεξεργαστή κειμένου"
    },
    "elementLock": {
      "lock": "Κλείδωμα",
      "unlock": "Ξεκλείδωμα",
      "lockAll": "Κλείδωμα όλων",
      "unlockAll": "Ξεκλείδωμα όλων"
    },
    "statusPublished": "Δημοσιευμένο",
    "sidebarLock": "Κρατήστε την πλαϊνή μπάρα ανοιχτή",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Δεν έχουν προστεθεί αντικείμενα ακόμη...",
    "hint_emptyLibrary": "Επιλέξτε ένα στοιχείο στον καμβά για να το προσθέσετε εδώ, ή εγκαταστήστε μια βιβλιοθήκη από το δημόσιο αποθετήριο, παρακάτω.",
    "hint_emptyPrivateLibrary": "Επιλέξτε ένα στοιχείο στον καμβά για να το προσθέσετε εδώ."
  },
  "buttons": {
    "clearReset": "Επαναφορά του καμβά",
    "exportJSON": "Εξαγωγή σε αρχείο",
    "exportImage": "Εξαγωγή εικόνας...",
    "export": "Αποθήκευση ως...",
    "copyToClipboard": "Αντιγραφή στο πρόχειρο",
    "save": "Αποθήκευση στο τρέχον αρχείο",
    "saveAs": "Αποθήκευση ως",
    "load": "Άνοιγμα",
    "getShareableLink": "Δημόσιος σύνδεσμος",
    "close": "Κλείσιμο",
    "selectLanguage": "Επιλογή γλώσσας",
    "scrollBackToContent": "Μετακινηθείτε πίσω στο περιεχόμενο",
    "zoomIn": "Μεγέθυνση",
    "zoomOut": "Σμίκρυνση",
    "resetZoom": "Επαναφορά μεγέθυνσης",
    "menu": "Μενού",
    "done": "Τέλος",
    "edit": "Επεξεργασία",
    "undo": "Αναίρεση",
    "redo": "Επαναφορά",
    "resetLibrary": "Καθαρισμός βιβλιοθήκης",
    "createNewRoom": "Δημιουργία νέου χώρου",
    "fullScreen": "Πλήρης οθόνη",
    "darkMode": "Σκοτεινή λειτουργία",
    "lightMode": "Φωτεινή λειτουργία",
    "zenMode": "Λειτουργία Zεν",
    "objectsSnapMode": "",
    "exitZenMode": "Έξοδος από την λειτουργία Zen",
    "cancel": "Ακύρωση",
    "clear": "Καθαρισμός",
    "remove": "Κατάργηση",
    "embed": "",
    "publishLibrary": "Δημοσίευση",
    "submit": "Υποβολή",
    "confirm": "Επιβεβαίωση",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Αυτό θα σβήσει ολόκληρο τον καμβά. Είσαι σίγουρος;",
    "couldNotCreateShareableLink": "Δεν ήταν δυνατή η δημιουργία συνδέσμου κοινής χρήσης.",
    "couldNotCreateShareableLinkTooBig": "Δεν ήταν δυνατή η δημιουργία κοινόχρηστου συνδέσμου: η σκηνή είναι πολύ μεγάλη",
    "couldNotLoadInvalidFile": "Δεν μπόρεσε να ανοίξει εσφαλμένο αρχείο",
    "importBackendFailed": "Η εισαγωγή από το backend απέτυχε.",
    "cannotExportEmptyCanvas": "Δεν είναι δυνατή η εξαγωγή κενού καμβά.",
    "couldNotCopyToClipboard": "Αδυναμία αντιγραφής στο πρόχειρο.",
    "decryptFailed": "Δεν ήταν δυνατή η αποκρυπτογράφηση δεδομένων.",
    "uploadedSecurly": "Η μεταφόρτωση έχει εξασφαλιστεί με κρυπτογράφηση από άκρο σε άκρο, πράγμα που σημαίνει ότι ο διακομιστής Excalidraw και τρίτα μέρη δεν μπορούν να διαβάσουν το περιεχόμενο.",
    "loadSceneOverridePrompt": "Η φόρτωση εξωτερικού σχεδίου θα αντικαταστήσει το υπάρχον περιεχόμενο. Επιθυμείτε να συνεχίσετε;",
    "collabStopOverridePrompt": "Η διακοπή της συνεδρίας θα αντικαταστήσει το προηγούμενο, τοπικά αποθηκευμένο σχέδιο. Είστε σίγουροι?\n\n(Αν θέλετε να διατηρήσετε το τοπικό σας σχέδιο, απλά κλείστε την καρτέλα του προγράμματος περιήγησης.)",
    "errorAddingToLibrary": "Αδυναμία προσθήκης αντικειμένου στη βιβλιοθήκη",
    "errorRemovingFromLibrary": "Αδυναμία αφαίρεσης αντικειμένου από τη βιβλιοθήκη",
    "confirmAddLibrary": "Αυτό θα προσθέσει {{numShapes}} σχήμα(τα) στη βιβλιοθήκη σας. Είστε σίγουροι;",
    "imageDoesNotContainScene": "Αυτή η εικόνα δεν φαίνεται να περιέχει δεδομένα σκηνής. Έχετε ενεργοποιήσει την ενσωμάτωση σκηνής κατά την εξαγωγή;",
    "cannotRestoreFromImage": "Η σκηνή δεν ήταν δυνατό να αποκατασταθεί από αυτό το αρχείο εικόνας",
    "invalidSceneUrl": "Δεν ήταν δυνατή η εισαγωγή σκηνής από το URL που δώσατε. Είτε έχει λάθος μορφή, είτε δεν περιέχει έγκυρα δεδομένα JSON Excalidraw.",
    "resetLibrary": "Αυτό θα καθαρίσει τη βιβλιοθήκη σας. Είστε σίγουροι;",
    "removeItemsFromsLibrary": "Διαγραφή {{count}} αντικειμένου(ων) από τη βιβλιοθήκη;",
    "invalidEncryptionKey": "Το κλειδί κρυπτογράφησης πρέπει να είναι 22 χαρακτήρες. Η ζωντανή συνεργασία είναι απενεργοποιημένη.",
    "collabOfflineWarning": "Δεν υπάρχει διαθέσιμη σύνδεση στο internet.\nΟι αλλαγές σας δεν θα αποθηκευτούν!"
  },
  "errors": {
    "unsupportedFileType": "Μη υποστηριζόμενος τύπος αρχείου.",
    "imageInsertError": "Αδυναμία εισαγωγής εικόνας. Προσπαθήστε ξανά αργότερα...",
    "fileTooBig": "Το αρχείο είναι πολύ μεγάλο. Το μέγιστο επιτρεπόμενο μέγεθος είναι {{maxSize}}.",
    "svgImageInsertError": "Αδυναμία εισαγωγής εικόνας SVG. Η σήμανση της SVG δεν φαίνεται έγκυρη.",
    "failedToFetchImage": "",
    "invalidSVGString": "Μη έγκυρο SVG.",
    "cannotResolveCollabServer": "Αδυναμία σύνδεσης με τον διακομιστή συνεργασίας. Παρακαλώ ανανεώστε τη σελίδα και προσπαθήστε ξανά.",
    "importLibraryError": "Αδυναμία φόρτωσης βιβλιοθήκης",
    "collabSaveFailed": "Η αποθήκευση στη βάση δεδομένων δεν ήταν δυνατή. Αν το προβλήματα παραμείνει, θα πρέπει να αποθηκεύσετε το αρχείο σας τοπικά για να βεβαιωθείτε ότι δεν χάνετε την εργασία σας.",
    "collabSaveFailed_sizeExceeded": "Η αποθήκευση στη βάση δεδομένων δεν ήταν δυνατή, ο καμβάς φαίνεται να είναι πολύ μεγάλος. Θα πρέπει να αποθηκεύσετε το αρχείο τοπικά για να βεβαιωθείτε ότι δεν θα χάσετε την εργασία σας.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Επιλογή",
    "image": "Εισαγωγή εικόνας",
    "rectangle": "Ορθογώνιο",
    "diamond": "Ρόμβος",
    "ellipse": "Έλλειψη",
    "arrow": "Βέλος",
    "line": "Γραμμή",
    "freedraw": "Σχεδίαση",
    "text": "Κείμενο",
    "library": "Βιβλιοθήκη",
    "lock": "Κράτησε επιλεγμένο το εργαλείο μετά το σχέδιο",
    "penMode": "Λειτουργία μολυβιού - αποτροπή αφής",
    "link": "Προσθήκη/ Ενημέρωση συνδέσμου για ένα επιλεγμένο σχήμα",
    "eraser": "Γόμα",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Ενέργειες καμβά",
    "selectedShapeActions": "Επιλεγμένες ενέργειες σχήματος",
    "shapes": "Σχήματα"
  },
  "hints": {
    "canvasPanning": "",
    "linearElement": "Κάνε κλικ για να ξεκινήσεις πολλαπλά σημεία, σύρε για μια γραμμή",
    "freeDraw": "Κάντε κλικ και σύρτε, απελευθερώσατε όταν έχετε τελειώσει",
    "text": "Tip: μπορείτε επίσης να προσθέστε κείμενο με διπλό-κλικ οπουδήποτε με το εργαλείο επιλογών",
    "embeddable": "",
    "text_selected": "Κάντε διπλό κλικ ή πατήστε ENTER για να επεξεργαστείτε το κείμενο",
    "text_editing": "Πατήστε Escape ή CtrlOrCmd+ENTER για να ολοκληρώσετε την επεξεργασία",
    "linearElementMulti": "Κάνε κλικ στο τελευταίο σημείο ή πάτησε Escape ή Enter για να τελειώσεις",
    "lockAngle": "Μπορείτε να περιορίσετε τη γωνία κρατώντας πατημένο το SHIFT",
    "resize": "Μπορείς να περιορίσεις τις αναλογίες κρατώντας το SHIFT ενώ αλλάζεις μέγεθος,\nκράτησε πατημένο το ALT για αλλαγή μεγέθους από το κέντρο",
    "resizeImage": "Μπορείτε να αλλάξετε το μέγεθος ελεύθερα κρατώντας πατημένο το SHIFT,\nκρατήστε πατημένο το ALT για να αλλάξετε το μέγεθος από το κέντρο",
    "rotate": "Μπορείς να περιορίσεις τις γωνίες κρατώντας πατημένο το πλήκτρο SHIFT κατά την περιστροφή",
    "lineEditor_info": "Κρατήστε πατημένο Ctrl ή Cmd και πατήστε το πλήκτρο Ctrl ή Cmd + Enter για επεξεργασία σημείων",
    "lineEditor_pointSelected": "Πατήστε Διαγραφή για αφαίρεση σημείου(ων),\nCtrlOrCmd+D για αντιγραφή, ή σύρετε για μετακίνηση",
    "lineEditor_nothingSelected": "Επιλέξτε ένα σημείο για να επεξεργαστείτε (κρατήστε πατημένο το SHIFT για να επιλέξετε πολλαπλά),\nή κρατήστε πατημένο το Alt και κάντε κλικ για να προσθέσετε νέα σημεία",
    "placeImage": "Κάντε κλικ για να τοποθετήσετε την εικόνα ή κάντε κλικ και σύρετε για να ορίσετε το μέγεθός της χειροκίνητα",
    "publishLibrary": "Δημοσιεύστε τη δική σας βιβλιοθήκη",
    "bindTextToElement": "Πατήστε Enter για προσθήκη κειμένου",
    "deepBoxSelect": "Κρατήστε πατημένο το CtrlOrCmd για να επιλέξετε βαθιά, και να αποτρέψετε τη μεταφορά",
    "eraserRevert": "Κρατήστε πατημένο το Alt για να επαναφέρετε τα στοιχεία που σημειώθηκαν για διαγραφή",
    "firefox_clipboard_write": "Αυτή η επιλογή μπορεί πιθανώς να ενεργοποιηθεί αλλάζοντας την ρύθμιση \"dom.events.asyncClipboard.clipboardItem\" σε \"true\". Για να αλλάξετε τις ρυθμίσεις του προγράμματος περιήγησης στο Firefox, επισκεφθείτε τη σελίδα \"about:config\".",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Αδυναμία εμφάνισης προεπισκόπησης",
    "canvasTooBig": "Ο καμβάς μπορεί να είναι μεγάλος.",
    "canvasTooBigTip": "Συμβουλή: προσπαθήστε να μετακινήσετε τα πιο απομακρυσμένα στοιχεία λίγο πιο κοντά μαζί."
  },
  "errorSplash": {
    "headingMain": "Συνέβη κάποιο σφάλμα. Προσπάθησε <button>φόρτωσε ξανά την σελίδα.</button>",
    "clearCanvasMessage": "Εάν το παραπάνω δεν δουλέψει, προσπάθησε <button>καθαρίσετε τον κανβά.</button>",
    "clearCanvasCaveat": " Αυτό θα προκαλέσει απώλεια της δουλειάς σου ",
    "trackedToSentry": "Το σφάλμα με αναγνωριστικό {{eventId}} παρακολουθήθηκε στο σύστημά μας.",
    "openIssueMessage": "Ήμασταν πολύ προσεκτικοί για να μην συμπεριλάβουμε τις πληροφορίες της σκηνής σου στο σφάλμα. Αν η σκηνή σου δεν είναι ιδιωτική, παρακαλώ σκέψου να ακολουθήσεις το δικό μας <button>ανιχνευτής σφαλμάτων.</button> Παρακαλώ να συμπεριλάβετε τις παρακάτω πληροφορίες, αντιγράφοντας και επικολλώντας το ζήτημα στο GitHub.",
    "sceneContent": "Περιεχόμενο σκηνής:"
  },
  "roomDialog": {
    "desc_intro": "Μπορείς να προσκαλέσεις άλλους να δουλέψουν μαζί σου.",
    "desc_privacy": "Μην ανησυχείς, η συνεδρία χρησιμοποιεί κρυπτογράφηση από σημείο σε σημείο, άρα οτιδήποτε κάνεις θα παραμείνει ανοιχτό μόνο σε εσένα. Ούτε οι μηχανές μας μπορούν να δουν τι κάνεις.",
    "button_startSession": "Έναρξη Συνεδρίας",
    "button_stopSession": "Τερματισμός Συνεδρίας",
    "desc_inProgressIntro": "Η ζωντανή συνεργασία με άλλους είναι σε ενεργή.",
    "desc_shareLink": "Μοιραστείτε τον σύνδεσμο με όποιον θέλετε να δουλέψετε μαζί:",
    "desc_exitSession": "Η διακοπή θα σας αποσυνδέσει από το δωμάτιο, αλλά θα μπορείτε να συνεχίσετε να δουλεύετε στον πίνακα, τοπικά. Σημειώσατε ότι αυτό δεν θα επηρεάσει τον πίνακα άλλων, και θα μπορούν ακόμα να συνεισφέρουν στην δική τους έκδοση.",
    "shareTitle": "Συμμετάσχετε σε μια ζωντανή συνεδρία συνεργασίας για το Excalidraw"
  },
  "errorDialog": {
    "title": "Σφάλμα"
  },
  "exportDialog": {
    "disk_title": "Αποθήκευση στο δίσκο",
    "disk_details": "Εξαγωγή δεδομένων σκηνής σε ένα αρχείο από το οποίο μπορείτε να εισάγετε αργότερα.",
    "disk_button": "Αποθήκευση σε αρχείο",
    "link_title": "Κοινόχρηστος σύνδεσμος",
    "link_details": "Εξαγωγή ως σύνδεσμο μόνο για ανάγνωση.",
    "link_button": "Εξαγωγή σε Σύνδεση",
    "excalidrawplus_description": "Αποθηκεύστε τη σκηνή στο χώρο εργασίας σας Excalidraw+.",
    "excalidrawplus_button": "Εξαγωγή",
    "excalidrawplus_exportError": "Δεν ήταν δυνατή η εξαγωγή στο Excalidraw+ αυτή τη στιγμή..."
  },
  "helpDialog": {
    "blog": "Διαβάστε το Blog μας",
    "click": "κλικ",
    "deepSelect": "Βαθιά επιλογή",
    "deepBoxSelect": "Βαθιά επιλογή μέσα στο πλαίσιο και αποτροπή συρσίματος",
    "curvedArrow": "Κυρτό βέλος",
    "curvedLine": "Κυρτή γραμμή",
    "documentation": "Εγχειρίδιο",
    "doubleClick": "διπλό κλικ",
    "drag": "σύρε",
    "editor": "Επεξεργαστής",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Βρήκατε πρόβλημα; Υποβάλετε το",
    "howto": "Ακολουθήστε τους οδηγούς μας",
    "or": "ή",
    "preventBinding": "Αποτροπή δέσμευσης βέλων",
    "tools": "Εργαλεία",
    "shortcuts": "Συντομεύσεις πληκτρολογίου",
    "textFinish": "Ολοκλήρωση επεξεργασίας (επεξεργαστής κειμένου)",
    "textNewLine": "Προσθήκη νέας γραμμής (επεξεργαστής κειμένου)",
    "title": "Βοήθεια",
    "view": "Προβολή",
    "zoomToFit": "Zoom ώστε να χωρέσουν όλα τα στοιχεία",
    "zoomToSelection": "Ζουμ στην επιλογή",
    "toggleElementLock": "Κλείδωμα/Ξεκλείδωμα επιλογής",
    "movePageUpDown": "Μετακίνηση σελίδας πάνω/κάτω",
    "movePageLeftRight": "Μετακίνηση σελίδας αριστερά/δεξιά"
  },
  "clearCanvasDialog": {
    "title": "Καθαρισμός καμβά"
  },
  "publishDialog": {
    "title": "Δημοσίευση βιβλιοθήκης",
    "itemName": "Όνομα αντικειμένου",
    "authorName": "Όνομα δημιουργού",
    "githubUsername": "GitHub username",
    "twitterUsername": "Twitter username",
    "libraryName": "Όνομα βιβλιοθήκης",
    "libraryDesc": "Περιγραφή βιβλιοθήκης",
    "website": "Ιστοσελίδα",
    "placeholder": {
      "authorName": "Όνομα ή όνομα χρήστη",
      "libraryName": "Όνομα της βιβλιοθήκης σας",
      "libraryDesc": "Περιγραφή της βιβλιοθήκης σας ώστε να βοηθήσει το κοινό να κατανοήσει τη χρήση της",
      "githubHandle": "Όνομα χρήστη στο GitHub (προαιρετικό), ώστε να μπορείτε να επεξεργαστείτε τη βιβλιοθήκη αφού υποβληθεί για αξιολόγηση",
      "twitterHandle": "Όνομα χρήστη Twitter (προαιρετικό), ώστε να γνωρίζουμε σε ποιον/η να δώσουμε εύσημα κατά την προώθηση μέσω Twitter",
      "website": "Σύνδεσμος για την προσωπική σας ιστοσελίδα ή αλλού (προαιρετικό)"
    },
    "errors": {
      "required": "Απαιτείται",
      "website": "Εισάγετε μια έγκυρη διεύθυνση URL"
    },
    "noteDescription": "Υποβάλετε τη βιβλιοθήκη σας για να συμπεριληφθεί στο <link>δημόσιο αποθετήριο βιβλιοθήκης</link>ώστε να χρησιμοποιηθεί από άλλα άτομα στα σχέδιά τους.",
    "noteGuidelines": "Η βιβλιοθήκη πρέπει πρώτα να εγκριθεί χειροκίνητα. Παρακαλώ διαβάστε τους <link>οδηγίες</link> πριν την υποβολή. Θα χρειαστείτε έναν λογαριασμό GitHub για την επικοινωνία και για να προβείτε σε αλλαγές εφ' όσον χρειαστεί, αλλά δεν είναι αυστηρή απαίτηση.",
    "noteLicense": "Με την υποβολή, συμφωνείτε ότι η βιβλιοθήκη θα δημοσιευθεί υπό την <link>Άδεια MIT, </link>που εν συντομία σημαίνει ότι ο καθένας μπορεί να τα χρησιμοποιήσει χωρίς περιορισμούς.",
    "noteItems": "Κάθε αντικείμενο της βιβλιοθήκης πρέπει να έχει το δικό του όνομα ώστε να μπορεί να φιλτραριστεί. Θα συμπεριληφθούν τα ακόλουθα αντικείμενα βιβλιοθήκης:",
    "atleastOneLibItem": "Παρακαλώ επιλέξτε τουλάχιστον ένα αντικείμενο βιβλιοθήκης για να ξεκινήσετε",
    "republishWarning": "Σημείωση: μερικά από τα επιλεγμένα αντικέιμενα έχουν ήδη επισημανθεί ως δημοσιευμένα/υποβεβλημένα. Θα πρέπει να υποβάλετε αντικείμενα εκ νέου μόνο για να ενημερώσετε μία ήδη υπάρχουσα βιβλιοθήκη ή υποβολή."
  },
  "publishSuccessDialog": {
    "title": "Η βιβλιοθήκη υποβλήθηκε",
    "content": "Ευχαριστούμε {{authorName}}. Η βιβλιοθήκη σας έχει υποβληθεί για αξιολόγηση. Μπορείτε να παρακολουθείτε τη διαδικασία<link>εδώ</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Καθαρισμός βιβλιοθήκης",
    "removeItemsFromLib": "Αφαίρεση επιλεγμένων αντικειμένων από τη βιβλιοθήκη"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "Τα σχέδιά σου είναι κρυπτογραφημένα από άκρο σε άκρο, έτσι δεν θα είναι ποτέ ορατά μέσα από τους διακομιστές του Excalidraw.",
    "link": "Blog post στην κρυπτογράφηση end-to-end στο Excalidraw"
  },
  "stats": {
    "angle": "Γωνία",
    "element": "Στοιχείο",
    "elements": "Στοιχεία",
    "height": "Ύψος",
    "scene": "Σκηνή",
    "selected": "Επιλεγμένα",
    "storage": "Χώρος",
    "title": "Στατιστικά για σπασίκλες",
    "total": "Σύνολο ",
    "version": "Έκδοση",
    "versionCopy": "Κάνε κλικ για αντιγραφή",
    "versionNotAvailable": "Έκδοση μη διαθέσιμη",
    "width": "Πλάτος"
  },
  "toast": {
    "addedToLibrary": "Προστέθηκε στη βιβλιοθήκη",
    "copyStyles": "Αντιγράφηκαν στυλ.",
    "copyToClipboard": "Αντιγράφηκε στο πρόχειρο.",
    "copyToClipboardAsPng": "Αντιγράφηκε {{exportSelection}} στο πρόχειρο ως PNG\n({{exportColorScheme}})",
    "fileSaved": "Το αρχείο αποθηκεύτηκε.",
    "fileSavedToFilename": "Αποθηκεύτηκε στο {filename}",
    "canvas": "καμβάς",
    "selection": "επιλογή",
    "pasteAsSingleElement": "Χρησιμοποίησε το {{shortcut}} για να επικολλήσεις ως ένα μόνο στοιχείο,\nή να επικολλήσεις σε έναν υπάρχοντα επεξεργαστή κειμένου",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "Διαφανές",
    "black": "Μαύρο",
    "white": "Λευκό",
    "red": "Κόκκινο",
    "pink": "Ροζ",
    "grape": "Σταφυλί",
    "violet": "Βιολετί",
    "gray": "Γκρι",
    "blue": "Μπλε",
    "cyan": "Κυανό",
    "teal": "Τιρκουάζ",
    "green": "Πράσινο",
    "yellow": "Κίτρινο",
    "orange": "Πορτοκαλί",
    "bronze": "Χαλκινο"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Όλα τα δεδομένα σας αποθηκεύονται τοπικά στο πρόγραμμα περιήγησης.",
      "center_heading_plus": "Μήπως θέλατε να πάτε στο Excalidraw+;",
      "menuHint": "Εξαγωγή, προτιμήσεις, γλώσσες, ..."
    },
    "defaults": {
      "menuHint": "Εξαγωγή, προτιμήσεις και άλλες επιλογές...",
      "center_heading": "Διαγράμματα. Εύκολα. Γρήγορα.",
      "toolbarHint": "Επιλέξτε ένα εργαλείο και ξεκινήστε να σχεδιάζεται!",
      "helpHint": "Συντομεύσεις και βοήθεια"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Πιο χρησιμοποιούμενα χρώματα",
    "colors": "Χρώματα",
    "shades": "Αποχρώσεις",
    "hexCode": "Κωδικός Hex",
    "noShades": "Δεν υπάρχουν διαθέσιμες αποχρώσεις για αυτό το χρώμα"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
